import { useContext } from 'react';
import { SDKContext } from './SDKProvider';
import type { SDK } from './types';

export function useSDK(): SDK {
  const sdk = useContext(SDKContext);
  if (!sdk) {
    throw new Error('useSDK must be used within an <SDKProvider>');
  }
  return sdk;
}
